import { Component, Prop, h } from '@stencil/core';

export interface ListItem {
  text: string;
  icon?: string;
}

@Component({
  tag: 'me-list',
  styleUrl: 'index.scss',
  shadow: false,
})
export class MeList {
  /**
   * Array of list items with optional icons
   */
  @Prop() items!: ListItem[];

  /**
   * Display list inline or in column
   * @default 'column'
   */
  @Prop() layout: 'inline' | 'column' = 'column';

  /**
   * List style type
   * @default 'plain'
   */
  @Prop() listType: 'plain' | 'icon' | 'numbered' = 'plain';

  /**
   * Default icon to use when listType is 'icon' and no specific icon provided
   */
  @Prop() defaultIcon?: string;

  /**
   * Inline icons during server-side rendering (SSR).
   * When true, icons are fetched from CDN on the server and inlined into HTML.
   * Only affects SSR - improves LCP for above-the-fold lists.
   */
  @Prop() iconInline?: boolean = false;

  render() {
    const classes = {
      'me-list': true,
      [`me-list--${this.layout}`]: true,
      [`me-list--${this.listType}`]: true,
    };

    const renderListItem = (item: ListItem, index: number) => {
      return (
        <li class="me-list__item">
          {this.listType === 'icon' && <me-icon name={item.icon || this.defaultIcon || 'interface--check'} class="me-list__icon" inline={this.iconInline}></me-icon>}
          {this.listType === 'numbered' && <span class="me-list__number">{index + 1}.</span>}
          <span class="me-list__text">{item.text}</span>
        </li>
      );
    };

    return <ul class={classes}>{this.items.map((item, index) => renderListItem(item, index))}</ul>;
  }
}
